export const HIGHLIGHT_DURATION_MS = 1_500;

export const HIGHLIGHT_CLASS = 'teamchat-field-anchor-highlight';
